import { render } from "./NewsSmallBox.vue?vue&type=template&id=4a6bca9c&scoped=true"
import script from "./NewsSmallBox.vue?vue&type=script&lang=js"
export * from "./NewsSmallBox.vue?vue&type=script&lang=js"

import "./NewsSmallBox.vue?vue&type=style&index=0&id=4a6bca9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a6bca9c"

export default script